import window from '../globalWrappers/window.js';
import translate from './translate.js';
import getAppRoot from '../utilities/getAppRoot.js';

function redirectToLogin(language = 'en_US')  {
  window.location.href = `/${getAppRoot()}/Account/Login${(window.location.search || '?')}&reval=${translate('sessionTimeout', language)}`;
}

export default redirectToLogin;
